/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateDutyDto
 */
export interface CreateUpdateDutyDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDutyDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDutyDto
     */
    psychologistUID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateDutyDto
     */
    doctorUID?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateDutyDto interface.
 */
export function instanceOfCreateUpdateDutyDto(value: object): value is CreateUpdateDutyDto {
    return true;
}

export function CreateUpdateDutyDtoFromJSON(json: any): CreateUpdateDutyDto {
    return CreateUpdateDutyDtoFromJSONTyped(json, false);
}

export function CreateUpdateDutyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDutyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'psychologistUID': json['psychologistUID'] == null ? undefined : json['psychologistUID'],
        'doctorUID': json['doctorUID'] == null ? undefined : json['doctorUID'],
    };
}

export function CreateUpdateDutyDtoToJSON(value?: CreateUpdateDutyDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'psychologistUID': value['psychologistUID'],
        'doctorUID': value['doctorUID'],
    };
}

